// extracted by mini-css-extract-plugin
export var root = "MarkdownIntro-module--root--2a5f4";